var EProductPlanPriceCurrency = /*#__PURE__*/ function(EProductPlanPriceCurrency) {
    EProductPlanPriceCurrency["EUR"] = "EUR";
    EProductPlanPriceCurrency["USD"] = "USD";
    return EProductPlanPriceCurrency;
}(EProductPlanPriceCurrency || {});
export { EProductPlanPriceCurrency };
